import { HttpStatusCode } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { urlToHttpOptions } from 'url';
import { DataService } from '../../../shared-services/cache-data.service';
import { CommonService } from '../../../shared-services/common.service';
import { MenuModel, MenuSide } from '../../models/sidebar-menu.models';
import { MenuService } from '../services/menu.service';
declare var $: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuList!: MenuSide[];
  //parentData: any[] = [];
  parentData: MenuSide[] = [];
  menuSideList: MenuSide[] = [];
  childLevel1!: MenuSide;
  childLevel2!: MenuSide;
  isPinned: boolean = false;
  lastIndex!: number;
  menuData!: any;
  private subscription: Subscription | undefined;
  constructor(private service: CommonService,
    private cachedService: DataService,
    private router: Router,
    private elementRef: ElementRef
  ) {
  }

  ngOnInit(): void {
    if (sessionStorage.getItem("menuIsPinned") == "true") {
      this.pinNavBar();
    }
    this.cachedService.menu.subscribe((x: any) => {
      if (x && x.data) {
        this.setMenuData(x);
      }
    });
  }
  isExpanded = false;
  @ViewChild("mainSider") mainSider: ElementRef | undefined;

  private setMenuData(result: any) {
    this.parentData = result.data.filter((f: any) => f.parentId == null);
    this.parentData.forEach((x: any, index: number) => {
      if (index == 0) {
        //sessionStorage.setItem('ISOCurrencyCode', x.isoCurrencyCode);
      }
      x.children = result.data.filter((y: any) => x.id == y.parentId);
      x.children.forEach((xc: any) => xc.children = result.data.filter((y: any) => xc.id == y.parentId));
    });
  }
  ngOnDestroy() {
    this.subscription!.unsubscribe(); // Unsubscribe to prevent memory leaks
  }
  toggleSidebar() {
    $('body').toggleClass('toggle-sidebar');
  }
  toggleNavBar(isCollapsed: boolean = false) {
    if (isCollapsed) {
      $('.main-container-wrap').removeClass("side-icon-expanded");
    } else {
      $('.main-container-wrap').addClass("side-icon-expanded");
    }
  }
  pinNavBar() {
    $('.main-container-wrap').toggleClass("side-icon-pinned");
    this.isPinned = !this.isPinned;
    if (this.isPinned) {
      sessionStorage.setItem('menuIsPinned', 'true');
    } else {
      sessionStorage.setItem('menuIsPinned', 'false');
    }
  }

  count: number = 0;
  collapse() {
    this.isExpanded = false;
    this.mainSider?.nativeElement.setAttribute('class', "side-icon-expanded");
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    this.mainSider?.nativeElement.setAttribute('class', "side-icon");
  }
  goToPage(item: any, index: number) {
    if (item != null) {
      this.setActiveNavItem(item.id);
      if (item.code.toLocaleLowerCase() == 'setting') {
        let foundChildRootesFirstPage = item.children.length > 0 ? (item.children[0].children.length > 0 ? item.children[0].children[0].code.replace(' ', '') : '') : '';
        if (foundChildRootesFirstPage) {
          this.router.navigate(['/' + item.code + '/' + foundChildRootesFirstPage + '/page/Search']);
        }
      }
      else if (item.code && item.code.toLowerCase() == 'home') {
        this.router.navigate(['/' + item.code.toLowerCase()]);
      }
      else if (item.code && item.code.toLowerCase() == 'profile')
      {
        this.router.navigate(['/' + item.code.toLowerCase() + '/page/edit']);
      }
      else {
        this.router.navigate(['/' + item.code + '/page/Search']);
      }
      if (this.lastIndex) {
        $('#main-div-tab-' + this.lastIndex).addClass('tab-pane fade');
      }
      this.lastIndex = index;
      // for side bar sub menu list
      $('#main-div-tab-' + index).removeClass('tab-pane fade');
    }
  }

  setActiveNavItem(id: number) {
    var activeLinks = $('.nav-link.active');
    if (activeLinks) {
      activeLinks.removeClass('active');
    }
    var navLink = $('#nav-link-' + id);
    if (navLink) {
      navLink.addClass('active');
    }
  }

  ngAfterViewChecked() {
    let urlhavingCode = this.router.url.split('/')[1];
    if (urlhavingCode && !urlhavingCode.includes('#')) {
      $('.sideMenu a').removeClass('active');
      $('.nav-link-' + urlhavingCode.toLowerCase()).addClass('active');
    }
  }
}



